import * as yup from 'yup';
import type { LabourItemDefinitionSummary } from '../../labour/types/labourItemTypes.ts';

/**
 * Form data type for adding labour items
 */
export interface AddLabourItemFormData {
  selectedDefinition: LabourItemDefinitionSummary | null;
  name?: string;
  description?: string | null;
  price: number;
}

/**
 * Validation schema for adding labour items
 * Following form-architecture.md Yup patterns
 */
export const addLabourItemSchema = yup.object().shape({
  selectedDefinition: yup
    .mixed()
    .nullable()
    .test(
      'either-definition-or-name',
      'Please select an existing labour item or provide a name for a new one',
      function (value) {
        const { name } = this.parent;
        // Either selectedDefinition OR name must be provided
        return value !== null || (name && name.trim().length > 0);
      }
    ),

  name: yup.string().when('selectedDefinition', {
    is: null,
    then: schema =>
      schema
        .required('Labour item name is required')
        .min(3, 'Name must be at least 3 characters')
        .max(100, 'Name cannot exceed 100 characters'),
    otherwise: schema => schema.nullable().optional(),
  }),

  description: yup
    .string()
    .max(500, 'Description cannot exceed 500 characters')
    .nullable()
    .optional(),

  price: yup
    .number()
    .required('Price is required')
    .positive('Price must be greater than zero')
    .test('two-decimals', 'Price must have at most 2 decimal places', value => {
      if (!value) return true;
      return Number.isInteger(value * 100);
    }),
});
